<template>
    <div class="layout-person">
        <slot name="person-header" v-bind:parent="parent">
            <div class="uk-section uk-section-medium uk-text-center uk-background-muted page-header">
                <div class="uk-light uk-container uk-container-small uk-text-center">
                    <router-link :to="parent.link" v-if="parent" class="text-green"><label>{{parent.menuTitle}}</label></router-link>
                    <h1 class="uk-margin-small-top">{{page.title}}</h1>
                    <h4 class="uk-margin-remove"><label class="text-blue">{{page.subtitle}}</label></h4>
                </div>
            </div>
        </slot>

        <div class="square uk-background-cover uk-card uk-card-default" v-bind:style="{ backgroundImage: `url(${page.image.smallSquare})` }" v-if="page?.image.smallSquare" />
        
        <slot name="default">
            <div />
            <div class="uk-section uk-section-medium uk-background-white">
                <div class="uk-container uk-container-tiny uk-margin-bottom uk-margin-large-top">
                    <h3 v-if="page.summary" class="uk-text-center">
                        <em class="text-light-blue">{{page.summary}}</em>
                    </h3>
                </div>
                <div class="uk-container uk-container-small">
                    <div class="content" v-html="page.content"></div>
                </div>
            </div>
            <div class="uk-section uk-section-medium uk-background-muted uk-light" v-if="page.secondaryContent">
                <div class="uk-container uk-container-small">
                    <div class="content" v-html="page.secondaryContent"></div>
                </div>
            </div>
        </slot>

    </div>
</template>
<script>

export default {
    props: ['page', 'parent'],
    data() {
        return {}
    }
}
</script>
